import { BasketCustomerOrderEntity } from '@genial/services';
import { useBreakpointValue } from '@genial/utils';
import { useNavigation } from '@react-navigation/native';
import React, { useState } from 'react';

import {
  BatchTicketResumeDetailTypeParam,
  SignedInNavigationScreenNavigationProp,
} from '../../../../../../routes/types';

import { RequiredAttentionItemDesktop } from './desktop';
import { RequiredAttentionItemMobile } from './mobile';
import { RequiredAttentionItemTablet } from './tablet';

interface RequiredAttentionItemProps {
  item: BasketCustomerOrderEntity;
}

export interface RequiredAttentionResponsiveItem extends RequiredAttentionItemProps {
  handleDetailsCustomer: () => void;
  sectionIsOpened: boolean;
  toggleSection: () => void;
  detailsButtonIsDisabled: boolean;
}

export const RequiredAttentionItem: React.FC<RequiredAttentionItemProps> = ({ item }) => {
  const [sectionIsOpened, setSectionIsOpened] = useState(false);
  const toggleSection = () => setSectionIsOpened((state) => !state);
  const detailsButtonIsDisabled = item.customerOffers?.length === 0;
  const { navigate } = useNavigation<SignedInNavigationScreenNavigationProp>();

  const handleDetailsCustomer = (selectedTab: BatchTicketResumeDetailTypeParam) => {
    navigate('BatchTicketResumeDetail', {
      type: selectedTab,
      basketCustomerOrderId: item.basketCustomerOrderId,
    });
  };

  const defaultOfferError = {
    errorId: 'errorId',
    errorTimestamp: new Date(),
    errorTraceId: 'errorTraceId',
    errorCode: 'offer_generic_error',
    errorTitle: 'Informações divergentes',
    errorDisplay: 'toast',
    errorMessage: 'Foram encontradas informações divergentes em relação a determinados ativos.',
    errorSuggest: 'Verifique os ativos adicionados',
    errorLanguage: 'pt-BR',
  };

  const props = {
    item: { ...item, errors: [defaultOfferError, ...(item?.errors ?? [])] },
    handleDetailsCustomer: () => handleDetailsCustomer('requiredAttention'),
    sectionIsOpened,
    toggleSection,
    detailsButtonIsDisabled,
  };

  const layout = useBreakpointValue({
    base: <RequiredAttentionItemMobile {...props} />,
    sm: <RequiredAttentionItemTablet {...props} />,
    lg: <RequiredAttentionItemDesktop {...props} />,
  });

  return layout;
};
